const nf = new Intl.NumberFormat()

export const n = (v) => (Number.isFinite(v) ? nf.format(v) : '—')

export function bytes(v) {
  if (!Number.isFinite(v)) return '—'
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let i = 0
  let x = v
  while (x >= 1024 && i < units.length - 1) {
    x /= 1024
    i++
  }
  return `${x < 10 && i > 0 ? x.toFixed(1) : Math.round(x)} ${units[i]}`
}

export const pct = (v) => `${Math.round((v ?? 0) * 100)}%`
